module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 487.2 465.2"
    }
  }, [_c('path', {
    attrs: {
      "stroke-width": "20",
      "stroke": "black",
      "fill": _vm.fillColor,
      "d": "M487 176a14 14 0 00-11-9l-152-22L255 8a13 13 0 00-24 0l-67 138-152 22a14 14 0 00-11 9 13 13 0 003 14l110 107-25 151a14 14 0 0013 16 13 13 0 007-1l135-72 136 71a14 14 0 007 1 14 14 0 0013-13 11 11 0 000-3l-27-151 110-107a13 13 0 004-14"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4c972da","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/cards/review/components/stars/components/star/Star.vue
// module id = 543e8e24deb066d35c31
// module chunks = 89